"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.HeaderLogoType = void 0;
var HeaderLogoType;
(function (HeaderLogoType) {
    HeaderLogoType["SVG"] = "svg";
    HeaderLogoType["IMAGE"] = "image";
    HeaderLogoType["TEXT"] = "text";
})(HeaderLogoType || (exports.HeaderLogoType = HeaderLogoType = {}));
